import clsx from 'clsx';
import { ComponentProps, useCallback } from 'react';

import { useLabel } from '~hooks/useLabels';
import { ViewVariant } from '~modules/media-library/model/ViewVariant';
import { RangeSlider } from '~modules/media-library/view/ViewVariantSlider/RangeSlider';

export function ViewVariantSlider({
  onChange,
  value,
  variants = [],
}: {
  onChange: (newValue: ViewVariant) => void;
  value: ViewVariant;
  variants: ViewVariant[];
}) {
  // labels
  const labelMediaLibraryViewSlider = useLabel('labelMediaLibraryViewSlider');

  const handleOnChange = useCallback<ComponentProps<typeof RangeSlider>['onChange']>(
    newIdx => {
      onChange?.(variants[newIdx]);
    },
    [onChange, variants],
  );

  // Derived values
  const countSteps = variants.length || 0;
  const idxValue = variants.indexOf(value) || 0;

  // Dont render if there is only one option available
  if (countSteps < 2) return null;

  return (
    <div className={clsx('ml--view-variant-slider', 'inline-flex items-center gap-2')}>
      <div className="select-none">{labelMediaLibraryViewSlider}</div>
      <RangeSlider
        steps={countSteps}
        value={idxValue}
        onChange={handleOnChange}
        className="ml--view-variant-slider--input"
      />
    </div>
  );
}
